import Vue from 'vue';
import store from './../store';
import { EventsService } from '@/services/EventsService';
import { FTProcess } from './FTProcess';
import _ from 'lodash';
import { GoodsObject } from './GoodsObject';
import { FTProcessRow } from './FTProcessRow';
import axios from 'axios';

export class FTFactoryTicket {
  processes: FTProcess[] = [];
  createdGoods: any[] = [];
  goodsLoaded = false;
  processIndex = -1;
  order: any;

  constructor(order: any, formVariable: any) {
    this.order = order;
    store.commit('resetGoods');
    if(formVariable.processes) {
      this.pushGoodsToStore(formVariable.processes);
      _.map(formVariable.processes, (processObject: any, processIndex: number) => {
        this.processIndex = processIndex;
        this.processes[processIndex] = new FTProcess(processObject, this.processIndex, this);
      });
    }
    Vue.set(formVariable, 'processes', this.processes);
    Vue.set(formVariable, 'createdGoods', this.createdGoods);
    Vue.set(formVariable, 'order', this.order._id);

    EventsService.createEvent('addProcessToFactoryTicket', this.addProcess, this);
    EventsService.createEvent('updateGoodsToStore', this.pushAllGoodsToStore, this);
    EventsService.createEvent('requestRmTransfer', this.createMaterialRequests, this);
  }

  // @TODO: deprecate when fixing FT popup in goods requests page
  pushAllGoodsToStore(inputGoods: GoodsObject[]) {
    if(this.goodsLoaded === false) {
      const renamedGoods = inputGoods.map((goodsObject : GoodsObject) => new GoodsObject(goodsObject, goodsObject.ftProcessRow));
      store.commit('addMultipleGoods', renamedGoods);
      this.goodsLoaded = true;
    }
  }

  getCurrentGoods(processes: any[]): GoodsObject[] {
    const currentGoods: GoodsObject[] = [];
    _.forEach(processes, (processObject: any) => {
      _.forEach(processObject.inputs, (inputRow: any) => {
        const goodsObject = _.get(inputRow, 'goodsObject');
        if(goodsObject) {
          currentGoods.push(new GoodsObject(goodsObject, goodsObject.ftProcessRow));
        }
      });
      _.forEach(processObject.outputs, (outputRow: any) => {
        const goodsObject = { ..._.get(outputRow, 'goodsObject'), _id: outputRow._id };
        if(goodsObject) {
          currentGoods.push(new GoodsObject(goodsObject, goodsObject.ftProcessRow));
        }
      });
    });
    return currentGoods;
  }

  pushGoodsToStore(processes: any[]) {
    store.commit('addMultipleGoods', this.getCurrentGoods(processes));
  }

  addProcess(newProcesses: any[]) {
    this.processIndex++;
    Vue.set(this.processes, this.processIndex, new FTProcess(newProcesses[newProcesses.length - 1], this.processIndex, this));
  }

  toJSON() {
    const { processes, order, createdGoods } = this;
    return { processes, order: order._id, createdGoods }
  }

  upsertCreatedGoodsObject(createdGood: any) {
    const goodToAdd = _.clone(createdGood);
    // eslint-disable-next-line
    const { name, createdAt, updatedAt, ...updatedGoodToAdd } = goodToAdd;
    const oldCreatedGoodIndex = this.createdGoods.findIndex(good => good._id === updatedGoodToAdd._id);
    if(oldCreatedGoodIndex !== -1) {
      this.createdGoods[oldCreatedGoodIndex] = updatedGoodToAdd;
    } else {
      this.createdGoods.push(updatedGoodToAdd);
    }
  }

  static isWithinFT(input: string | number) {
    return /^p.*/.test(`${input}`);
  }

  static getFTProcessRow(processes: FTProcess[], query: string) {
    const outputKeys: any[] | null = query.match(/p(\d*)([oi])(\d*)/i);
    const processKey = outputKeys![1];
    const processRowType = outputKeys![2] == 'i' ? 'inputs' : 'outputs';
    const processRowKey = outputKeys![3];
    if (processKey && processRowType && processRowKey) {
      return processes[processKey-1][processRowType][processRowKey-1];
    }
    throw new Error(`no ProcessRow found in process with "${query}"`)
  }

  async createMaterialRequests() {
    store.commit('setSnackbar', { serverMessage: 'sending Automatic RM Transfer Requests', show: true, color: 'secondary' });
    const requests: any[] = [];
    _.forEach(this.processes, (process: FTProcess) => {
      _.forEach(process.inputs, (inputProcessRow: FTProcessRow) => {
        if(inputProcessRow.goodsObject.status == 'RM') {
          const data = {
            rawMaterial: inputProcessRow._id,
            locationFrom: 'Warehouse',
            locationTo: 'Factory',
            quantity: inputProcessRow.quantity
          };
          requests.push(axios.post('/api/v1/goods/transfer/request', data));
        }
      });
    });
    await Promise.all(requests);
    store.commit('setSnackbar', { serverMessage: 'RM Transfer Requested', show: true, color: 'primary' });

  }
  
}